<span class="bpe-status bpe-status-{{kebabCase(status)}}">
    <span [innerText]="status"></span>
</span>